<template>
	<div v-loading="loading" class="base_scroll_page">
		<!-- 主体区域 -->
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">型号：</span>
					<el-input v-model="search_model" class="b_inp" placeholder="型号"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">芯片ID：</span>
					<el-input v-model="search_chipId" class="b_inp" placeholder="芯片ID"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="search_startDate"
						:editable="false"
						placeholder="开始时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchDateChange"
					>
					</el-date-picker>
				</div>
				
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="search_endDate"
						:editable="false"
						placeholder="结束时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchDateChange"
					>
					</el-date-picker>
				</div>
				
				<div class="b_item">
					<span class="b_label">机构：</span>
					<el-select v-model="search_oid" class="b_inp" filterable placeholder="请选择" :clearable="true">
						<el-option
							v-for="v in allOrganization"
							:key="v.id"
							:label="v.name"
							:value="v.id">
						</el-option>
					</el-select>
				</div>
				
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- action -->
			<div style="margin-top: 20px;font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="oname"
						label="所属机构"
					>
					</el-table-column>
					<el-table-column
						prop="onumber"
						label="机构内编号"
					>
					</el-table-column>
					<el-table-column
						prop="deviceId"
						label="设备ID"
					>
					</el-table-column>
					<el-table-column
						prop="deviceTypeLabel"
						label="设备类型"
					>
					</el-table-column>
					<el-table-column
						prop="screenResolution"
						label="屏幕分辨率"
					>
					</el-table-column>
					<el-table-column
						prop="deviceModel"
						label="设备型号"
					>
					</el-table-column>
					<el-table-column
						prop="gamma"
						label="gamma"
					>
					</el-table-column>
					<el-table-column
						prop="deviceSize"
						label="设备尺寸"
					>
					</el-table-column>
					<el-table-column
						prop="softwareVersion"
						label="软件版本号"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增弹框 -->
		<add v-model="add_display" @onSuccess="addSuccess"></add>
		<!-- 新增弹框 end -->
		
		<!-- 修改弹框 -->
		<update v-model="update_display" :obj="update_data" @onSuccess="updateSuccess"></update>
		<!-- 修改弹框 end -->
	</div>
</template>

<script>
	import Add from './components/add.vue';
	import Update from './components/update.vue';
	import { mapState } from 'vuex';
	import Api from '../../../../../api/index.js';
	
	export default{
		mounted() {
			this.getData();
		},
		data() {
			return{
				loading: false,
				
				search_model: '',
				search_chipId: '',
				search_startDate: '',
				search_endDate: '',
				search_oid: '',
				
				tableData: [],
				total: 0,
				currentPage: 1,
				
				add_display: false,
				
				update_display: false,
				update_data: {}
			}
		},
		computed: {
			...mapState([
				'allOrganization',
				'allDeviceType'
			])
		},
		methods: {
			/************************ @Events *******************************/
			// 切换查询时间
			handleSearchDateChange () {
				this.compareSearchDate();
			},
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.getData();
			},
			// 点击新增
			handleAddClick() {
				this.add_display = true;
			},
			// 点击修改
			handleUpdateClick(data) {
				this.update_data = {...data};
				this.update_display = true;
			},
			// 点击删除
			handleDeleteClick(obj) {
				const that = this;
				that.$confirm(
					'此操作将删除该检测设备，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.deleteDevice(obj.id);
					}
				).catch(
					() => {}
				);
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getData();
				}
			},
			// 新增成功
			addSuccess() {
				this.getData();
			},
			// 修改成功
			updateSuccess() {
				this.getData();
			},
			
			/************************ @Function *******************************/
			// 获取列表数据
			getData() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: 10,
					enterpriseId: that.search_oid
				};
				Api.findVisualDetectionDevices(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						res.data.data.records.forEach(v => {
							list.push({
								id: v.deviceId,
								oid: v.enterpriseId,
								oname: v.enterpriseName,
								onumber: v.deviceNo,
								deviceId: v.uuid,
								deviceTypeFlag: v.enterpriseType,
								deviceTypeLabel: that.mapDeviceTypeToName(v.enterpriseType),
								screenResolution: v.resolvingPower,
								deviceModel: v.deviceType,
								gamma: v.gamma,
								deviceSize: v.deviceSize,
								softwareVersion: v.softVersion
							});
						});
						that.tableData = list;
						that.total = res.data.data.total;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 删除检测设备
			deleteDevice(id) {
				const that = this;
				that.loading = true;
				Api.deleteVisualDetectionDevice(id).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.getData();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始时间和结束时间
			compareSearchDate () {
				if (this.search_startDate && this.search_endDate) {
					var startDate = new Date(this.search_startDate).getTime(),
						endDate = new Date(this.search_endDate).getTime();
					if (endDate < startDate) {
						this.search_endDate = '';
						this.$message.warning('结束时间不能小于开始时间');
					}
				}
			},
			// 把设备类型转为文字
			mapDeviceTypeToName(label) {
				let result = '';
				this.allDeviceType.forEach(v => {
					v.id == label && (result = v.name);
				});
				return result;
			}
		},
		components: {
			Add,
			Update
		}
	}
</script>

<style>
</style>
